import { render, staticRenderFns } from "./setupDetail.vue?vue&type=template&id=295df408&scoped=true"
import script from "./setupDetail.vue?vue&type=script&lang=js"
export * from "./setupDetail.vue?vue&type=script&lang=js"
import style0 from "./setupDetail.vue?vue&type=style&index=0&id=295df408&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "295df408",
  null
  
)

export default component.exports